import { BaseGameStrategy } from './BaseGameStrategy';

import {
  getBalanceUrl,
  getBonusSpinUrl,
  getBuyBonusUrl,
  getInitialStateUrl,
  getPreBonusSpinUrl,
  getSpinUrl,
} from '../../../core/endpoints';
import { httpClient } from '../../../core/httpClient';
import { historyHelperService } from '../../helperServices/HistoryHelperService';
import { BONUS_TICKET_TYPE } from '../../../stateManagment';

export class RealGameStrategy extends BaseGameStrategy {
  async spin(body) {
    const data = { ...this._createSpinBody(), ...body };
    const { amount } = data;
    return await httpClient.post(getSpinUrl({ isDemo: false }), data).then(res => {
      historyHelperService.add({
        time: new Date().toISOString(),
        betAmount: amount,
        result: res.result,
        winAmount: res.winAmount,
        odd: res.odd,
      });
      return res;
    });
  }

  _createPreBonusSpinBody() {
    return {
      bonusType: BONUS_TICKET_TYPE.getValue(),
    };
  }

  async preBonusSpin(body) {
    return await httpClient.post(getPreBonusSpinUrl({ isDemo: false }), {}, {
      params: this._createPreBonusSpinBody(),
    });
  }

  async getBalance() {
    return await httpClient.get(getBalanceUrl())
  }

  async buyBonus(body) {
    const data = { ...this._createBuyBonusBody(), ...body };
    return await httpClient.post(getBuyBonusUrl({ isDemo: false }), data);
  }

  async bonusSpin() {
    return await httpClient.post(getBonusSpinUrl({ isDemo: false })).then((res) => {
      return res
    });
  }

  async getInitialState(options) {
    return await httpClient.get(getInitialStateUrl({ isDemo: false }), {
      params: this._createInitialStateParams(),
    });
  }

}
